import { TemplateModel } from '@/components/ui';
import { FORMATTER_CLASSIFICATION_FUNCTION_ID } from '@/constants';
import { generateId } from '@/utils';

import {
  currencyFormatter,
  dateFormatter,
  highConfidenceValidator,
  ibanFormatter,
  numericFormatter,
} from './common.ts';

export const GENERIC: TemplateModel = {
  fields: [
    {
      id: generateId(),
      type: 'single-value',
      name: 'Text',
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Vendor',
        promptHintPlaceholder: 'e.g. The name of the vendor or supplier',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Numeric',
      formatters: [numericFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Total amount',
        promptHintPlaceholder: 'e.g. The total amount including taxes and fees',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Date',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: '.e.g. Due date',
        promptHintPlaceholder: '.e.g. The invoice due date',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Currency',
      formatters: [currencyFormatter],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: 'Currency',
        promptHintPlaceholder: 'e.g. The ISO currency',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'Classification',
      formatters: [
        {
          id: generateId(),
          functionId: FORMATTER_CLASSIFICATION_FUNCTION_ID,
          name: 'Classification',
          description: 'Enforce one of the defined classes',
          config: {
            labels: [],
          },
        },
      ],
      validators: [highConfidenceValidator],
      helpProps: {
        defaultName: undefined,
        namePlaceholder: 'e.g. Document type',
        promptHintPlaceholder: 'e.g. The type of document',
      },
    },
    {
      id: generateId(),
      type: 'single-value',
      name: 'IBAN',
      formatters: [ibanFormatter],
      validators: [highConfidenceValidator],
      comingSoon: true,
    },
  ],
  sampleDocuments: [],
};
